import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import { B2B_API_URL, APP_ID } from "./constants"
import { getDeviceId, inBrowser } from "@omnichannel/ace-b2b-elements"
import { getCompanyId, getUserEmail } from '../utils/utils'


let deviceId = undefined
if (inBrowser) {
    getDeviceId().then(result => {
        deviceId = result
    })
}

const appMiddleware = new ApolloLink((operation, forward) => {
    let bearerAccessToken = "x"
    const accessToken = (inBrowser && localStorage.getItem("access-token")) || ""
    if (accessToken.length) {
        bearerAccessToken = `Bearer ${accessToken}`
    }

    const branch = JSON.parse(
        (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
    )
    let branchId = branch._id

    operation.setContext(({ headers = {} }) => {
        headers = {
            ...headers,
            appId: APP_ID,
            companyId: getCompanyId(),
            deviceId,
            ...(branchId ? { branchId } : {}),
            Authorization: bearerAccessToken,
            email: getUserEmail()
        }

        return { headers }
    })
    return forward(operation)
})

const httpLink = new HttpLink({
    uri: B2B_API_URL,
    fetch,
})

const b2bClient = new ApolloClient({
    cache: inBrowser
        ? new InMemoryCache().restore(window.__APOLLO_STATE__)
        : new InMemoryCache(),
    link: from([appMiddleware, httpLink]),
})

export default b2bClient
